import React, { useEffect, useState } from "react";
import { t } from "@lingui/macro";
import { i18n } from "idc-ui-react";
// Fluent IU
import { Stack, Spinner } from "@fluentui/react";
// Our modules
import { store } from "../../stores/Main";
import AccessDenied from "./AccessDenied";

const rootStackStyles = {
  root: {
    height: "calc(100vh - (100vh - 100%))",
    minWidth: "990px",
    overflowY: "hidden"
  }
};

const Notifications = () => {
  const { notificationRedirectUrl } = store.state;
  const [redirectUrl, setRedirectUrl] = useState("");
  const [accessDenied, setAccessDenied] = useState(false);

  useEffect(() => {
    if (notificationRedirectUrl) setRedirectUrl(notificationRedirectUrl);
    else setAccessDenied(true);
  }, [notificationRedirectUrl]);

  // Redirect to the notification item.
  if (redirectUrl) {
    window.location.href = redirectUrl;
  }
  if (accessDenied) {
    return <AccessDenied />;
  }

  return (
    <Stack
      styles={rootStackStyles}
      horizontalAlign="center"
      verticalAlign="center"
    >
      <Spinner label={i18n._(t`Loading data...`)} />
    </Stack>
  );
};

export default Notifications;
